<template>
    <div class="helpCenter">
  <Navbar :backNative="false" title="" />
      <div class="title">{{detail.title}}</div>
        <div class="richText" v-html="detail.content"></div>
    </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import http from '../../utils/http'
export default {
  data(){
      return{
          detail:{}
      }
  },
  components:{
      Navbar
  },
  mounted(){
      http.getHelpDetail({id:this.$route.query.id}).then(res=>{
          console.log(res)
          this.detail=res
      })
    console.log()
  },
  activated(){
        http.getHelpDetail({id:this.$route.query.id}).then(res=>{
          console.log(res)
          this.detail=res
      })
    console.log()
  },
  methods:{
      
  },

}
</script>

<style lang="less" scoped>
.helpCenter{
    
 .title{
      width: calc(100% - 32px);
       margin: 0 auto;
        font-size: 15px;
        color: #222030;
        font-weight: 600;
        margin-top: 12px;
    }
    .richText{
    width: calc(100% - 32px);
    margin: 0 auto;
    margin-top: 12px;
     /deep/ img{
       max-width: 100% 
     }
   
}
}

</style>
